import React, { useState, useEffect } from 'react';
import ImageCard from './ImageCard';

const MasonryGrid = ({ images, onImageClick }) => {
  const [columns, setColumns] = useState(3);

  useEffect(() => {
    const updateColumns = () => {
      const width = window.innerWidth;
      if (width < 640) {
        setColumns(1);
      } else if (width < 1024) {
        setColumns(2);
      } else if (width < 1536) {
        setColumns(3);
      } else {
        setColumns(4);
      }
    };

    updateColumns();
    window.addEventListener('resize', updateColumns);
    return () => window.removeEventListener('resize', updateColumns);
  }, []);

  // Distribute images across columns
  const distributeImages = () => {
    const cols = Array.from({ length: columns }, () => []);
    
    images?.forEach((image, index) => {
      const colIndex = index % columns;
      cols?.[colIndex]?.push({ ...image, originalIndex: index });
    });
    
    return cols;
  };

  const imageColumns = distributeImages();

  if (images?.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="text-muted-foreground text-lg mb-2">No images found</div>
        <p className="text-muted-foreground text-sm">
          Try adjusting your search or filter criteria
        </p>
      </div>
    );
  }

  return (
    <div className="grid gap-4" style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
      {imageColumns?.map((column, colIndex) => (
        <div key={colIndex} className="space-y-4">
          {column?.map((image) => (
            <ImageCard
              key={`${image?.originalIndex}-${image?.id}`}
              image={image}
              onImageClick={onImageClick}
              index={image?.originalIndex}
            />
          ))}
        </div>
      ))}
    </div>
  );
};

export default MasonryGrid;